import React from 'react';
import { Icons } from '../components/Icons';

const UnauthorizedSplash = ({ onExit }) => (
    <div className="fixed inset-0 bg-[#050000] z-[200] flex flex-col items-center justify-center p-4 text-center font-sans overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-10 text-red-600">
            <div className="w-[200vw] h-[200vw] md:w-[100vw] md:h-[100vw] transition-transform duration-[20000ms] ease-linear scale-100 hover:scale-150 transform-gpu" style={{ animation: 'growScale 20s forwards' }}>
                <Icons.TriangleLogo className="w-full h-full" />
            </div>
        </div>
        <style>{`@keyframes growScale { 0% { transform: scale(0.8); } 100% { transform: scale(2); } }`}</style>
        <div className="relative z-10">
            <div className="h-20 w-20 md:h-24 md:w-24 mx-auto text-red-600 mb-8 drop-shadow-[0_0_15px_rgba(220,38,38,0.8)]">
                <Icons.TriangleLogo className="w-full h-full" />
            </div>
            <h1 className="text-4xl md:text-6xl font-black text-white tracking-widest uppercase mb-4">ACCESS DENIED</h1>
            <p className="text-red-500 font-bold tracking-[0.4em] uppercase text-xs md:text-lg mb-12">UNAUTHORIZED FOR LEVEL 0</p>
            <button onClick={onExit} className="border border-red-900 bg-black text-red-500 hover:bg-red-900 hover:text-white px-8 py-4 text-xs font-bold tracking-widest uppercase transition-all shadow-[0_0_15px_rgba(220,38,38,0.2)] hover:shadow-[0_0_25px_rgba(220,38,38,0.5)]">
                SEVER CONNECTION
            </button>
        </div>
    </div>
);

export default UnauthorizedSplash;